/**
 * Toggle cart navigation drawer
 */
export const CART_DISPLAY = 'CART_DISPLAY';

/**
 * Remove item from cart
 */
export const CART_ITEM_REMOVE = 'CART_ITEM_REMOVE';

/**
 * Set quantity for card item
 */
export const CART_ITEM_SET_QUANTITY = 'CART_ITEM_SET_QUANTITY';

/**
 * Adds new order item in cart and assign id for it
 */
export const CART_ITEM_ADD = 'CART_ITEM_ADD';

/**
 * Update order item in store
 */
export const CART_ITEM_UPDATE = 'CART_ITEM_UPDATE';

/**
 * Remove all items from cart
 */
export const CART_RESET = 'CART_RESET';

/**
 *  Get list of restaurants
 */
export const ORDER_PAY = 'ORDER_PAY';

/**
 *  Capture order
 */
export const CAPTURE_ORDER = 'CAPTURE_ORDER';

/**
 *  Get terminal connection token
 */
export const TERMINAL_CONNECTION_TOKEN = 'TERMINAL_CONNECTION_TOKEN ';

/**
 * Set selected order type
 */
export const ORDER_SET_TYPE = 'ORDER_SET_TYPE';

/**
 * Set selected rest
 */
export const ORDER_SET_RESTAURANT = 'ORDER_SET_RESTAURANT';

/**
 * Set selected terminal
 */
export const ORDER_SET_TERMINAL = 'ORDER_SET_TERMINAL';

/**
 * Create order
 */
export const ORDER_CREATE = 'ORDER_CREATE';

/**
 * Calc order info without aloha.
 * @type {string}
 */
export const ORDER_CALC = 'ORDER_CALC';

/**
 * Load already created orders for current user from API.
 */
export const ORDERS_LOAD = 'ORDERS_LOAD';

/**
 * Load order by uuid.
 */
export const ORDER_LOAD = 'ORDER_LOAD';

/**
 * Save order to cart.
 */
export const ORDER_SAVE = 'ORDER_SAVE';

/**
 *  Cart expand.
 */
export const CART_EXPAND = 'CART_EXPAND';

/**
 * Cart collapse.
 */
export const CART_COLLAPSE = 'CART_COLLAPSE';

/**
 * Save order products to cart.
 */
export const CART_SAVE_ORDER = 'CART_SAVE_ORDER';

/**
 * Create order for payment.
 */
export const CART_PREPARE_ORDER = 'CART_PREPARE_ORDER';

/**
 * Calculate order without aloha.
 * @type {string}
 */
export const CART_CALC_ORDER = 'CART_CALC_ORDER';

/**
 * Clear orders history.
 */
export const CART_CLEAR_USER_ORDERS = 'CART_CLEAR_USER_ORDERS';

/**
 * Reset order data.
 */
export const ORDER_RESET = 'ORDER_RESET';

/**
 * Update orders data.
 */
export const ORDER_PATCH = 'ORDER_PATCH';

/**
 * Update order id.
 */
export const ORDER_UPDATE_ID = 'ORDER_UPDATE_ID';

/**
 * Get Payment Intent.
 */
export const PAYMENT_INTENT = 'PAYMENT_INTENT';

/**
 * Show checkout dialog.
 * @type {string}
 */
export const SHOW_CHECKOUT_DIALOG = 'SHOW_CHECKOUT_DIALOG';

/**
 * Hide checkout dialog.
 * @type {string}
 */
export const HIDE_CHECKOUT_DIALOG = 'HIDE_CHECKOUT_DIALOG';

export const DISCOUNT_CODE_CHANGED = 'DISCOUNT_CODE_CHANGED';

export const UPDATE_DISCOUNT = 'UPDATE_DISCOUNT';

export const SET_DISCOUNT_CODE_UPDATING = 'SET_DISCOUNT_CODE_UPDATING';

export const SET_DISCOUNT_ERRORS = 'SET_DISCOUNT_ERRORS';

export default {
  CART_DISPLAY,
  CART_ITEM_ADD,
  CART_ITEM_UPDATE,
  CART_ITEM_REMOVE,
  CART_ITEM_SET_QUANTITY,
  CART_RESET,
  CART_CLEAR_USER_ORDERS,
  ORDER_PAY,
  ORDER_SET_TYPE,
  ORDER_SET_RESTAURANT,
  ORDER_SAVE,
  ORDERS_LOAD,
  ORDER_LOAD,
  ORDER_CREATE,
  CART_EXPAND,
  CART_COLLAPSE,
  CART_SAVE_ORDER,
  CART_PREPARE_ORDER,
  ORDER_PATCH,
  ORDER_SET_TERMINAL,
  ORDER_RESET,
  ORDER_UPDATE_ID,
  PAYMENT_INTENT,
  SHOW_CHECKOUT_DIALOG,
  HIDE_CHECKOUT_DIALOG,
  DISCOUNT_CODE_CHANGED,
  UPDATE_DISCOUNT,
  SET_DISCOUNT_CODE_UPDATING,
  SET_DISCOUNT_ERRORS,
};



// WEBPACK FOOTER //
// ./src/apps/cart/store/types.js